import React from 'react';
import styles from './tableHeaderCell.module.scss';
import clsx from 'clsx';
import SortArrow from 'assets/icons/sort-arrow.svg?react';
import SortArrowHover from 'assets/icons/sort-arrow-hover.svg?react';
import { ContextMenuPreparingEvent } from 'devextreme/ui/data_grid';

type OwnProps = {
  caption: string;
  dataField: string;
  sortBy?: string | null;
  desc: boolean;
  isSortingBlocked?: boolean;
};

export const TableHeaderCell = (props: OwnProps) => {
  const { dataField, desc, caption, sortBy, isSortingBlocked } = props;

  const isSorted = dataField === sortBy && !isSortingBlocked;

  return (
    <div
      className={clsx(styles.rowContainer, styles.flexEnd)}
      onClick={(e) => {
        if (isSortingBlocked) {
          e.stopPropagation();
        }
      }}
    >
      <div
        className={clsx(
          isSorted ? styles.black : styles.hoverSortArrow,
          isSortingBlocked && styles.default,
        )}
      >
        {caption}
      </div>
      {!isSortingBlocked ? (
        isSorted ? (
          <div className={styles.sortIconContainer}>
            <SortArrow className={clsx(!desc && styles.reverted)} />
          </div>
        ) : (
          <div className={clsx(styles.sortIconContainer, styles.displayNone)}>
            <SortArrowHover className={clsx(styles.reverted)} />
          </div>
        )
      ) : null}
    </div>
  );
};

export const onContextMenuPreparing = (
  e: ContextMenuPreparingEvent<any, number>,
) => {
  if (e.target === 'header' && e.items) {
    e.items = [];
  }
};
